module.exports = __webpack_public_path__ + "assets/sentiment_neutral.dbb7fc04.svg";